/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedDetailFramingOptions_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpSharedDetailFramingOptions_user";
};
export type PdpSharedDetailFramingOptions_user$data = PdpSharedDetailFramingOptions_user;
export type PdpSharedDetailFramingOptions_user$key = {
    readonly " $data"?: PdpSharedDetailFramingOptions_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDetailFramingOptions_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailFramingOptions_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'cca59e9c3fb17cd1c91d7779951003f1';
export default node;
